import axios from "axios";

import { userLogout } from "./user";
import { getAuthHeader } from "../headers";

// ===================================
// LOADING / ERROR / SUCCESS
// ===================================
export const managersLoading = () => {
	return {
		type: "MANAGERS_LOADING"
	};
};

export const managersError = err => {
	return {
		type: "MANAGERS_ERROR",
		error: err
	};
};

export const managersSuccess = data => {
	return {
		type: "MANAGERS_SUCCESS",
		data
	};
};

// Get managers from backend route
export function getManagers(){
    return (dispatch, getState) => {
        dispatch(managersLoading());

        return axios
            .get(process.env.REACT_APP_API_URL + "managers", {
                headers: getAuthHeader(getState().user, true)
            })
            .then(response => {
                if (response.data.status === 403) {
					dispatch(userLogout("reviewer"));
					return Promise.resolve(response);
				} else if (response.data.status && response.data.status !== 200) {
					dispatch(managersError(response.data.errors));
					return Promise.resolve(response);
				} else {
					dispatch(managersSuccess(response.data));
					return Promise.resolve(response);
				}
            })
            .catch(err => {
				dispatch(managersError({ general: err }));
			});
    };
}

// Add manager to backend
export function addManager(data) {
	return (dispatch, getState) => {
		dispatch(managersLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "managers/add", data, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status === 403) {
					dispatch(userLogout("admin"));
				} else if (response.data.status !== 200) {
					dispatch(managersError(response.data.errors));
					return Promise.resolve(response);
				}

				dispatch(managersSuccess(response.data));
				return Promise.resolve(response);
			})
			.catch(err => {
				dispatch(managersError({ general: err }));
			});
	};
}

// delete manager from backend
export function deleteManager(data) {
	return (dispatch, getState) => {
		dispatch(managersLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "managers/delete", {
                id: data
            }, {
				headers: getAuthHeader(getState().user, true)
			})
			.then(response => {
				if (response.data.status === 403) {
					dispatch(userLogout("admin"));
				} else if (response.data.status !== 200) {
					dispatch(managersError(response.data.errors));
					return Promise.resolve(response);
				}

				dispatch(managersSuccess(response.data));
				return Promise.resolve(response);
			})
			.catch(err => {
				dispatch(managersError({ general: err }));
			});
	};
}


// WEBPACK FOOTER //
// ./src/store/actions/managers.js